// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__W1LCb","loader":"Loader_loader__RX5ji","load3":"Loader_load3__gSKDy","customStyles":"Loader_customStyles__p1xj9"};